// extracted by mini-css-extract-plugin
export default {"box":"RemoveTags_box__bR7hX","selectTitle":"RemoveTags_selectTitle__iXZG3","title":"RemoveTags_title__5dXA9","inputTitle":"RemoveTags_inputTitle__PDc87"};